<template>
	<div class="total-box" :style="lineProgress">
		<Hed v-show="isHead"></Hed>
		<router-view></router-view>
	</div>
	<!-- <div style="width: 100%;height: 100%;">
            <Hed v-show="isHead"></Hed>
            <router-view></router-view>
        </div> -->
</template>

<script>
	import Hed from '../../components/phoneHeader/headerPage'
	import Foot from '../../components/phoneHeader/footerPhone'
	export default {
		name: "indexPhone",
		components: {
			Hed,
			Foot
		},
		computed:{
			lineProgress(){
				const style = {}
				style.width = this.screenWidth +'px';
				return style
			}
		},
		data() {
			return {
				isShow: true,
				isHead: true
			}
		},
		watch: {
			$route: {
				handler: function(val, oldVal) {
					if (val.path == "/bugListphone") {
						this.isShow = false
					} else {
						this.isShow = true
					}
					if (val.path == '/bugInfoPhone' || val.path == '/focusInfo' || val.path == '/reportInfo') {
						this.isHead = false
					} else {
						this.isHead = true
					}
				},
				// 深度观察监听
				deep: true
			}
		},
	}
</script>

<style scoped>
.total-box{
	height: 100%;
	overflow-y: auto;
}
</style>
